import React from "react";
import {
  CheckCircle,
  Clock3,
  XCircle,
  MessageSquare,
  BarChart3,
} from "lucide-react";

const getCardStyle = (title = "") => {
  const lower = title.toLowerCase();

if (lower.includes("success")) {
  return {
    icon: CheckCircle,
    bg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    accent: "bg-emerald-500",
    glow: "group-hover:shadow-emerald-200",
    gradient: "from-emerald-500/10 to-transparent",
  };
}

if (lower.includes("failed")) {
  return {
    icon: XCircle,
    bg: "bg-red-50",
    iconColor: "text-red-600",
    accent: "bg-red-500",
    glow: "group-hover:shadow-red-200",
    gradient: "from-red-500/10 to-transparent",
  };
}

if (lower.includes("pending")) {
  return {
    icon: Clock3,
    bg: "bg-amber-50",
    iconColor: "text-amber-600",
    accent: "bg-amber-500",
    glow: "group-hover:shadow-amber-200",
    gradient: "from-amber-500/10 to-transparent",
  };
}

if (lower.includes("total")) {
  return {
    icon: MessageSquare,
    bg: "bg-cyan-50",
    iconColor: "text-cyan-600",
    accent: "bg-cyan-500",
    glow: "group-hover:shadow-cyan-200",
    gradient: "from-cyan-500/10 to-transparent",
  };
}

return {
  icon: BarChart3,
  bg: "bg-violet-50",
  iconColor: "text-violet-600",
  accent: "bg-violet-500",
  glow: "group-hover:shadow-violet-200",
  gradient: "from-violet-500/10 to-transparent",
};
};

const DashboardCards = ({ cards = [] }) => {
  if (!cards.length) return null;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4 mb-6">
      {cards.map((card, index) => {
        const style = getCardStyle(card.title);
        const Icon = style.icon;

        return (
          <div
            key={index}
            className={`group relative min-h-[100px] max-h-[110px] overflow-hidden rounded-xl bg-white border border-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${style.glow}`}
          >
             {/* Left Accent Line */}
  <div
    className={`absolute left-0 top-0 h-full w-1 ${style.accent} rounded-l-2xl transition-all duration-300 group-hover:w-2`}
  />
            {/* Gradient Background */}
            <div
              className={`absolute inset-0 bg-gradient-to-br ${style.gradient} opacity-0 group-hover:opacity-100 transition-all duration-500`}
            />
            <div
  className={`absolute left-0 top-0 h-full w-1 ${style.border} rounded-l-2xl`}
/>

            <div className="relative px-4 py-3 flex items-center justify-between">
  <div>
    <p className="text-sm text-gray-500 font-medium">
      {card.title}
    </p>

    <h2 className="mt-2 text-3xl font-bold text-gray-900">
      {Number(card.value).toLocaleString()}
    </h2>
  </div>

  <div
    className={`h-12 w-12 rounded-xl ${style.bg}
    flex items-center justify-center transition-all duration-500
                group-hover:rotate-12
                group-hover:scale-110`}
  >
    <div className="absolute inset-0 rounded-xl bg-white/30 blur-md" />
    <Icon size={22} className={`${style.iconColor} relative transition-transform duration-500 group-hover:scale-110`} />
  </div>
</div>

            {/* Bottom Hover Line */}
            <div
              className={`absolute bottom-0 left-0 h-1 bg-gradient-to-r ${style.gradient}
              w-0 group-hover:w-full transition-all duration-500`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default DashboardCards;